import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import { Menu, MenuButton, MenuLink, MenuList } from "@reach/menu-button";
import { useDispatch, useSelector } from "react-redux";
import yourAccountIcon from "../../../assets/images/Account.svg";
import { getCatalogId, getStoreId } from "../../AppContext/selectors";
import ArrowUp from "../../../assets/images/arrow-up.svg";
import ArrowDown from "../../../assets/images/arrow-down.svg";
import { emitMenuOpen, useMenuAutoClose } from "./menuBus";

const StyledMenuList = styled(MenuList)`
  background-color: var(--sv-color-dark-green);
  margin-top: 5px;
  box-shadow: 8px 8px 8px 0px rgba(0, 0, 0, 0.15);
  &::after {
    content: " ";
    position: absolute;
    bottom: 100%;
    left: 52px;
    top: -5px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent var(--sv-color-dark-green) transparent;
  }
  &:focus {
    outline: none;
  }
  position: relative;
  z-index: 10;
  overflow: visible;
`;
const StyledMenuLink = styled(MenuLink)`
  font-family: var(--sv-font-sans);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 44px;
  text-decoration: none;
  display: block;
  padding-left: 20px;
  padding-right: 20px;
  color: var(--sv-color-white) !important;
  border-bottom: 1px solid var(--sv-color-dark-gray);
  &[data-reach-menu-item][data-selected] {
    font-weight: bold;
  }
  &:focus {
    outline: none;
  }
`;

const YourAccountMenu = ({
  accountDetailsLink,
  orderHistoryLink,
  managePaymentsLink,
  myRewardLink,
  logoutLink,
  translationKey,
  currentFileRequired,
  activeClass,
  user,
  activeMenu,
}) => {
  const [clicked, setClicked] = useState(false);
  const [isLoaded, setLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuId = "your-account-menu";
  const dispatch = useDispatch();
  const availableItems = [
    "my-setup",
    "my-orders-menu",
    "my-statement-menu",
    "my-rewards",
  ];

  const storeId = useSelector(getStoreId);
  const catalogId = useSelector(getCatalogId);
  useMenuAutoClose(menuId, isOpen, buttonRef);

  const handleMenuUp = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuOut = (e) => {
    if (clicked) setClicked(false);
  };
  const handleMenuClick = (e) => {
    if (clicked) {
      e.preventDefault();
      setClicked(false);
    }
  };

  const subItemsSelected = () => {
    return availableItems.findIndex((item) => item == activeMenu) !== -1;
  };

  return (
    <Menu
      onOpen={() => {
        setIsOpen(true);
        emitMenuOpen(menuId);
      }}
      onClose={() => setIsOpen(false)}
    >
      {({ isExpanded }) => (
        <React.Fragment>
          <MenuButton
            ref={buttonRef}
            className={`your-account-btn ${
              subItemsSelected() ? "headerMenuActive" : ""
            }`}
          >
            <img
              className="your-account-icon"
              alt="your account"
              src={yourAccountIcon}
              style={{ fontSize: "16px;" }}
            />{" "}
            {translationKey(currentFileRequired["YOUR_ACCOUNT"])}
            <img alt="" src={isExpanded ? ArrowUp : ArrowDown} />
          </MenuButton>
          <StyledMenuList>
            <StyledMenuLink
              href={accountDetailsLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("my-setup")}
            >
              {translationKey(currentFileRequired["MY_SETUP"])}
            </StyledMenuLink>
            <StyledMenuLink
              href={orderHistoryLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("my-orders-menu")}
            >
              {translationKey(currentFileRequired["MY_ORDERS"])}
            </StyledMenuLink>
            <StyledMenuLink
              href={managePaymentsLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
              className={activeClass("my-statement-menu")}
            >
              {translationKey(currentFileRequired["MY_STATEMENT"])}
            </StyledMenuLink>
            {user && user.isLoyaltyUser ? (
              <StyledMenuLink
                href={myRewardLink}
                onClick={handleMenuClick}
                onMouseUp={handleMenuUp}
                onMouseOut={handleMenuOut}
                className={activeClass("my-rewards")}
              >
                {translationKey(currentFileRequired["MY_REWARDS"])}
              </StyledMenuLink>
            ) : null}
            <StyledMenuLink
              href={logoutLink}
              onClick={handleMenuClick}
              onMouseUp={handleMenuUp}
              onMouseOut={handleMenuOut}
            >
              {translationKey(currentFileRequired["LOGOUT"])}
            </StyledMenuLink>
          </StyledMenuList>
        </React.Fragment>
      )}
    </Menu>
  );
};

YourAccountMenu.propTypes = {
  className: PropTypes.string,
};

export default YourAccountMenu;
